"use strict";

class PluginCreator {
  constructor() {
    this.listeners = [];
  }

  on(cb) {
    if (!this.listeners.includes(cb)) {
      this.listeners.push(cb);
    }
  }

  off(cb) {
    const idx = this.listeners.indexOf(cb);

    if (idx >= 0) {
      this.listeners.splice(idx, 1);
    }
  }

  sendChange(evt) {
    for (let n = 0; n < this.listeners.length; n++) {
      this.listeners[n](evt);
    }
  }

  create() {
    return [];
  }

}

module.exports = PluginCreator;